import type { PropsWithChildren } from 'react';
import { isMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

export const FilterDevice = ({ children }: PropsWithChildren) => {
  const { devicesToDisplay, editMode } = useSettings();

  const deviceConditions = {
    mobile: isMobile(),
    desktop: !isMobile()
  };

  const isShowChat = devicesToDisplay?.some(
    (device) => deviceConditions[device]
  );

  if (isShowChat || editMode) {
    return children;
  }

  return null;
};
